// "use client";
"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";

import { VueAppHeroData, vueStatsData, vueSolutionsAndProcessData, vueTechnologiesData, vueAboutData, vueFaqs } from "src/utils/mock/vueAppData";

export default function VueJSDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const vueProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const webApp = project.platforms?.toLowerCase().includes("web");

    const hasVueTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("vue"));

    return isActive && webApp && hasVueTech;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: vueProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={VueAppHeroData} />
      <TechStats stats={vueStatsData} />

      <WhyChooseUs data={vueSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={vueTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={vueAboutData} mainTitle="About VueJS Development" />
        </div>
      </section>

      <FAQSection faqs={vueFaqs} />
      <CommonContactSection />
    </div>
  );
}
